export default __webpack_public_path__ + "static/media/check-circle.085b395b.svg";